import BaseCalendarIteractiveController from "./base_calendar_iteractive_controller";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends BaseCalendarIteractiveController {
  static targets = ['form', 'inputDate', 'dayList', 'dayTab'];

  static values = {
    selectedDayIndex: Number,
    calendarService: { type: String, default: 'calendar-professor-service' }
  };

  connect() {
    this.element[this.identifier] = this;
    AjaxLoader.hide();
    this.initializeCardProperties();
    this.showDay(this.selectedDayIndexValue);
  }

  // Override to select cards by data-schedule instead of .card class
  initializeCardProperties() {
    this.element.querySelectorAll('[data-schedule]').forEach((card) => {
      window.matchMedia('(max-width: 576px)').matches
        ? this.initializeModalCardDetails(card)
        : this.initializeTippyCardDetails(card);
    });

    $('body').on('click', '.c-card a.c-card__menu-item', (ev) => {
      const tippyRoot = ev.currentTarget.closest('[data-tippy-root]');
      if (tippyRoot) tippyRoot._tippy.hide();
    });

    $('body').on('click', '.c-card a.c-card__menu-item.company-answer', (ev) => {
      ev.preventDefault();
      this.updateCompanyAnswer(ev.currentTarget);
    });
  }

  selectDay(event) {
    const dayIndex = parseInt(event.currentTarget.dataset.dayIndex, 10);
    this.showDay(dayIndex);
  }

  showDay(dayIndex) {
    this.dayListTargets.forEach((list, i) => {
      list.classList.toggle('hidden', i !== dayIndex);
    });
    this.dayTabTargets.forEach((tab, i) => {
      tab.classList.toggle('active-day', i === dayIndex);
    });
  }

  prevWeek() {
    this.navigateWeeks(-7);
  }

  nextWeek() {
    this.navigateWeeks(7);
  }

  navigateWeeks(days) {
    const [year, month, day] = this.inputDateTarget.value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + days);
    this.inputDateTarget.value = [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0')
    ].join('-');
    this.submitForm();
  }
}
